import Card, { CardProps } from '@mui/material/Card';
import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';

interface StyledCardProps extends CardProps {
    selected?: boolean;
}

interface StyledBoxProps extends BoxProps {
    selected?: boolean;
}
  
export const GroupCard = styled(Card, { 
    shouldForwardProp: (prop) => prop !== 'selected' 
})<StyledCardProps>(({ selected, theme }) => ({    
    backgroundColor: '#FFF',
    border: '1px solid #D9D9D9',
    boxSizing: 'border-box',
    borderRadius: '10px',
    color: '#202020',
    letterSpacing: '0.07rem',
    minHeight: '100px',
    // minWidth: '270px',
    display: 'flex',
    // padding: '0 0 0 16px',

    ...(selected && {
        backgroundColor: "#111224",
        color: "#FFF"
    }),
    // textAlign: 'center',
    // fontSize: '60px',
    
    // justifyContent: 'center',
    // alignItems: 'center'
}));

export const GroupName = styled(Card, { 
    shouldForwardProp: (prop) => prop !== 'selected' 
})<StyledBoxProps>(({ selected, theme }) => ({   
    marginLeft: '10%',
    backgroundColor: '#111224',
    color: '#FFF',
    borderRadius: '100%',
    height: '2.1em',
    width: '2.1em',
    textAlign: 'center',
    fontSize: '2.375rem',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    ...(selected && {
        backgroundColor: "#FFF",
        color: '#111224',
    }),
}));

    //border: `1px solid ${theme.palette.divider}`,
//   styled(Box) => (
//     <MuiAccordion disableGutters elevation={0} square {...props} />
//   ))(({ theme }) => ({
//     && {
//     })   

